module.exports = __webpack_public_path__ + "img/4.41794668.png";